<script lang="ts" setup>
import { useAppUpdate } from '@/composables/useAppUpdate'

const { showUpdateDialog, availableVersion, dismiss, openAppStore } = useAppUpdate()
</script>

<template>
  <v-dialog
    v-model="showUpdateDialog"
    :persistent="false"
    max-width="400"
  >
    <v-card>
      <v-card-title>Update available</v-card-title>
      <v-card-text>
        Platcop {{ availableVersion }} is available on the App Store. Update now to get the latest version.
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn
          variant="text"
          @click="dismiss"
        >
          Later
        </v-btn>
        <v-btn
          color="primary"
          variant="elevated"
          @click="openAppStore"
        >
          Update now
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
